/**
 * @author       tae@zumper.com (Tae Yoon)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  Detail monetized similar listings reducer
 */

import { nullReducer, payloadKeyReducer } from '@zcode/reducers'
import type { MonetizedSimilarListings } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'

import { CLEAR_ENTITY } from '../../entity/constants/index'
import {
  CLEAR_MONETIZED_SIMILAR_LISTINGS,
  RECEIVE_MONETIZED_SIMILAR_LISTINGS,
} from '../constants/index'

import { type Actions, metaReducer } from './meta'

export const monetizedSimilarListingsReducer = combineReducers<MonetizedSimilarListings, Actions>({
  data: handleActions<MonetizedSimilarListings['data'], Actions>(
    {
      [CLEAR_MONETIZED_SIMILAR_LISTINGS]: nullReducer,
      [CLEAR_ENTITY]: nullReducer,
      [RECEIVE_MONETIZED_SIMILAR_LISTINGS]: payloadKeyReducer('monetizedSimilarListings'),
    },
    null
  ),
  meta: metaReducer,
})
